import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import DetailsInfo from "./components/info";
import { useBreadcrumbs } from "../../../contexts/breadcrumb";
import { usePriorityDetailsStyles } from "./styles";
import { usePriorityDetails } from "../../../services/api-tansquery/priority/details";
import Accessible from "@material-ui/icons/Accessible";


export default function PriorityDetails() {
    const history = useHistory();
    const { setBreadcrumbs } = useBreadcrumbs();
    const { id } = useParams<{ id: string }>();
    const { classes } = usePriorityDetailsStyles();
    const { data: priority, isLoading } = usePriorityDetails(Number(id));

    useEffect(() => {
        setBreadcrumbs((prev) => {
            const homeBreadcrumb = prev.find((_, index) => index === 0);
            return [
                homeBreadcrumb,
                {
                    label: "Prioridades",
                    path: "/prioridades",
                    icon: Accessible
                },
                {
                    label: "Informações",
                    path: "",
                }
            ]
        });
    }, [setBreadcrumbs]);

    return (
        <Box className={classes.root}>
            <Box>
                <Button
                    className={classes.backButton}
                    startIcon={<ChevronLeft />}
                    onClick={() => history.goBack()}
                >
                    Voltar
                </Button>
            </Box>
            {isLoading ? (
                <Box className={classes.loading}>
                    <span>Carregando informações...</span>  
                </Box>
            ) : <DetailsInfo priority={priority} />}
            
        </Box >
    );
}